import { render } from "./Column202307.vue?vue&type=template&id=b8dd667c&scoped=true"
import script from "./Column202307.vue?vue&type=script&lang=js"
export * from "./Column202307.vue?vue&type=script&lang=js"

import "./Column202307.vue?vue&type=style&index=0&id=b8dd667c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8dd667c"]])

export default __exports__